// extracted by mini-css-extract-plugin
module.exports = {"container":"Devices_container__3bM5W","title":"Devices_title__1m_sH","icon":"Devices_icon__VS25E"};